import { render, staticRenderFns } from "./CheckupMethodologyWrapper.vue?vue&type=template&id=0dbab712&scoped=true&"
import script from "./CheckupMethodologyWrapper.vue?vue&type=script&lang=js&"
export * from "./CheckupMethodologyWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbab712",
  null
  
)

export default component.exports